<template>
  <v-layout row>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="close">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="success"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-flex xs12 sm6 md6 offset-sm4>
      <v-card class="mt-5" width="500">
        <v-toolbar color="red" dark>
          <v-toolbar-title class="headline">
            Reset your password
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <form ref="form">
              <v-layout row>
                <v-text-field
                  v-model="insertItem.email"
                  :rules="emailRules"
                  label="Email Address"
                  required
                ></v-text-field>
              </v-layout>
              <v-layout>
                <v-btn class="success mx-0" :loading="loading" @click="save">Reset Password</v-btn>
              </v-layout>
              <p class="mt-3 mb-1 custom-font-size">
                New to DataDash?
                <router-link
                  to="/signup"
                  tag="span"
                  style="cursor: pointer; color: #42a5f5"
                >
                  Sign Up
                </router-link>
              </p>
              <p class="custom-font-size">
                Are you exist in DataDash?
                <router-link
                  to="/signin"
                  tag="span"
                  style="cursor: pointer; color: #42a5f5"
                >
                  Sign In
                </router-link>
              </p>
            </form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm4 offset-sm4>
      <verify-pin />
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { ROOT_URL } from "@/api/connectingUrls";
import router from "../../router";
import VerifyPin from "../auth/VerifyPin";
export default {
  components: {
    VerifyPin,
  },
  data: () => ({
    error: 0,
    errorMsg: "",
    snackbar: false,
    y: "top",
    x: "right",
    loading:false,
    timeout: 3000,
    apiUrl: "forgot-password",
    insertItem: {
      email: "",
    },
    defaultItem: {
      email: "",
    },
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
  }),
  methods: {
    close() {
      this.error = false;
      this.snackbar = false;
      setTimeout(() => {
        this.insertItem = Object.assign({}, this.defaultItem);
      }, 300);
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      // console.log(this.insertItem);
      try {
        this.loading=true;
        return axios
          .post(`${ROOT_URL}/${this.apiUrl}`, this.insertItem, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.error == 0) {
              this.errorMsg = response.data.errorMsg;
              this.snackbar = true;
              setTimeout(() => {
                // this.$router.push({ name: 'verify-pin', params: { email: this.insertItem.email} });
                this.$router.push({
                  name: "reset-password",
                  params: { email: this.insertItem.email },
                });
                // router.push("/verify-pin");
              }, 1000);
              this.loading=false;
            } else {
              this.error = response.data.error;
              this.errorMsg = response.data.errorMsg;
            }
            this.loading=false;
          });
      } catch (error) {
        // console.log(error);
      }
      this.close();
    },
  },
};
</script>
<style scoped>
.custom-font-size {
  font-size: 13px;
}
</style>
